import React from "react";

import { Button, IconPlus, Label } from "@busbud/horizon";

import { useAppContext } from "@app/helpers/hooks";

import { clickedAddPassenger } from "../../../../../../tracking/account-tracking";

interface Props {
  button_disabled?: boolean;
  onAddPassenger: () => void;
}

export const AddPassenger: React.FC<Props> = ({
  button_disabled = false,
  onAddPassenger
}) => {
  const { tracker, translator } = useAppContext();

  const addPassenger = () => {
    tracker.track(clickedAddPassenger());
    onAddPassenger();
  };

  return (
    <div className="flex flex-col items-center justify-between gap-100 sm:flex-row sm:gap-200 md:gap-600">
      <div className="flex flex-col gap-100">
        <Label as="h2" size="lg" fontWeight="bold">
          {translator.t("!accounts.passengers.add-passengers.title")}
        </Label>
        <Label as="span" size="md" className="text-color-tertiary">
          {translator.t("!accounts.passengers.add-passengers.description")}
        </Label>
      </div>
      <Button
        variant="contained"
        size="lg"
        iconStart={<IconPlus size="md" />}
        onClick={addPassenger}
        isDisabled={button_disabled}
        className="whitespace-nowrap"
      >
        {translator.t("!accounts.passengers.add-passenger")}
      </Button>
    </div>
  );
};
